import React, { Component } from 'react';
import { Modal, ModalBody } from "reactstrap";
import './new-homework.scss';
import { Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import Filter from './filter/filter'
import DropdownV5 from '../../common/dropdown-v5/dropdown';
import Dropdown from '../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../common/dropdown-v4/dropdown';
import DropdownV6 from '../../common/dropdown-v6/dropdown';
import Path from '../../routes/routes-path'
import ConceptDetail from './concept-detail/concept-detail'
// import ConceptDetail from './question-detail/question-detail'
// import Report from '../completion-report/completion-report'
import HomeworkApi from '../../../apis/homework'
import SchoolUserApi from '../../../apis/student'
import QuestionList from './questions-list/questions-list';
import TestQuestionList from '../../clicker-assessment/new-test/questions-list-v2/questions-list'
import QuestionListFromHomework from '../../class-work-V1/new-homework/questions-list/questions-list'
import Loading from '../../common/loading/loading'
import CommonUtils from '../../../utility/common-utilities';
import EloDetail from '../../class-work-V1/homework-list/elo-detail/elo-detail'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import SessionCache from '../../routes/session-cache';
import TestApi from '../../../apis/test';
import CommonApi from '../../../apis/common';


class NewHomeWork extends Component {

    state = {
        isAdaptive: this.props.type == "ADAPTIVE_CLASSWORK",
        changeSchoolworkType: false,
        reloadQuestions: true,
        isDurationSelected: false,
        numberOfQuestions: 0,
        approximateTime: 0,
        studentListLength: 0,
        selectSingleQuestionFromElo: false,
        studentList: [],
        eloDropdownItems: [],
        homeworkDropdownItems: [],
        selectedHomeworkId: '',
        selectedIndex: '',
        selectedHomeworkMore: '',
        selectedContentAssessment: false,
        selectedHomeworkBasedStudentGrouping: false,
        selectedTab: 2,
        availabeSets: [],
        selectedSet: [],
        contents: [],
        selectedFilter: [],
        selectOneQuestionPerELO: false,
        categories: [
            {
                type: "NOVICE",
                title: "NOVICE",
                maxPercentage: 50,
                students: [],
                colorClass: "purble-header",
                selectedCriterion: 1
            },
            {
                type: "PROFICIENT",
                title: "PROFICIENT",
                minPercentage: 50,
                maxPercentage: 80,
                students: [],
                colorClass: "orange-header",
                selectedCriterion: 1
            },
            {
                type: "ADVANCED",
                title: "ADVANCED",
                minPercentage: 80,
                students: [],
                colorClass: "litebule-header",
                selectedCriterion: 1
            }
        ],
        criterionDropdownItems: [{ title: "Start from level 1", value: 1 }, { title: "Start from level 2", value: 2 }, { title: "Start from level 3", value: 3 }]
    }

    tabs = [
        {
            title: 'Questions List',
            value: 2
        },
        {
            title: 'All Students',
            value: 1
        }
    ]

    filterHash = {}
    durationList = { mixed: [] }

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()
    }

    componentDidMount() {
        // console.log(this.props)
        this.getApplicationConfiguration()
    }

    getApplicationConfiguration() {
        let payload = {
            type: 'ASSIGNMENT_DURATION'
        }

        CommonApi.getApplicationConfiguration(payload).then(res => {
            this.durationList = res.durationList
        }).catch(err => {
            console.log(err)
        })

    }

    changeSchoolworkType() {
        this.setState({ changeSchoolworkType: !this.state.changeSchoolworkType })
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 6000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onClickCreate() {

        let type = [this.props.type]

        if (this.state.isAdaptive) {
            this.onCreateAdaptive()
            return
        }

        if (!this.state.studentListLength) {
            console.log('No Students found with Roll Number')
            alert("No Students Found with Roll Number")
            return;
        }

        if (this.saving) return
        let payload = {
            ...this.state.payload,
            type: type ? type : this.props.type,
            homeworkType: [this.props.type],
            questionSource: 'QUESTION_SET',
            setsCovered: this.state.setsCovered
        }


        if (this.state.selectedConcept && this.state.selectedConcept.length) {
            payload.concepts = this.state.selectedConcept
        }

        payload.approximateQuestions = this.state.questionCount || 0
        payload.approximateTime = this.state.approximateTime || 0
        if (this.state.selectedDuration?.value) {
            payload.approximateTime = this.state.selectedDuration?.value
        }
        payload.selectSingleQuestionFromElo = this.state.selectSingleQuestionFromElo || false
        let validate = this.validatePayload(payload)
        if (!validate) {
            this.setState({ isCreate: true })
            return
        }
        this.saving = true
        this.setState({ isLoading: true })

        if (this.props.type === 'ADAPTIVE_CLASSWORK') {

            let criteriaHash = {}
            payload.concepts = [payload.concepts]

            for (let i = 0; i < this.state.categories.length; i++) {
                criteriaHash[this.state.categories[i].type] = { level: this.state.categories[i].selectedCriterion }

            }
            payload.criterion = criteriaHash
        }

        //    if(this.state.contents.length) {
        //     payload.contentIdList = this.state.contents.map(item => item._id)
        //    }

        let contentIdList = []
        let contentsHash = {}
        if (this.state.selectedContentAssessment) {
            payload.selectedContentAssessment = this.state.selectedContentAssessment
            payload.contentsHash = this.state.contentsHash

            Object.keys(this.state.contentsHash).forEach(item => contentIdList.push(item))

        } else {
            let contents = this.state.contents

            contents.forEach(item => {
                if (item.questions.length) {
                    item.questions.forEach(question => {
                        contentsHash[question._id] = { contentId: question._id, eloId: question.eloId, selected: true }
                        contentIdList.push(question._id)
                    })
                }
            })

            payload.contentsHash = contentsHash
            payload.selectedContentAssessment = false
        }
        // this.state.contents.forEach(item => {
        //     if (item.questions && item.questions.length) {
        //         item.questions.forEach(content => {
        //             contentIdList.push(content._id)
        //         })
        //     }
        // })

        payload.contentIdList = contentIdList


        // console.log("called", payload)

        HomeworkApi.createHomeworkForClickerPractice(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false })

            console.log("created Homework")

            let homework = { ...response.data, ...payload, created: true }
            if (!homework.totalUsers) {
                console.log("show popup 1")
                this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(homework, "WHATSAPP")
            } else {

                console.log("show popup 2", this.props.delegate)

                this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(homework)
            }
            homework.point = 10
            if (homework.point) {
                this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(homework)
            }
            this.props?.delegate?.hideNewHomework && this.props.delegate.hideNewHomework(true)
        }).catch(err => {
            this.saving = false
            this.setState({ isLoading: false })
        })
    }

    onCreateAdaptive() {
        let type = this.state.changeSchoolworkType ? 'ADAPTIVE' : 'ADAPTIVE_CLASSWORK'

        if (this.saving) return
        let payload = {
            ...this.state.payload,
            type: type ? type : this.props.type,
            categories: this.state.categories
        }
        payload.approximateQuestions = this.state.questionCount || 0
        payload.approximateTime = this.state.approximateTime || 0
        payload.selectSingleQuestionFromElo = this.state.selectSingleQuestionFromElo || false
        let validate = this.validatePayload(payload)
        if (!validate) {
            this.setState({ isCreate: true })
            return
        }
        this.saving = true
        this.setState({ isLoading: true })

        HomeworkApi.createAdaptiveHomework(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false })

            let homework = { ...response.data, ...payload, created: true }
            console.log(homework)
            if (!homework.totalUsers) {
                this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(homework, "WHATSAPP")
            } else {
                this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(homework)
            }
            homework.point = 10
            if (homework.point) {
                this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(homework)
            }
            this.props?.delegate?.hideNewHomework && this.props.delegate.hideNewHomework(true)
        }).catch(err => {
            this.saving = false
            this.setState({ isLoading: false })
        })
    }

    validatePayload = (payload) => {
        if (!payload.board) {
            this.setState({ selectBoardMessage: true })
            return false
        }

        if (!payload.class) {
            this.setState({ selectClassMessage: true })
            return false
        }

        if (!payload.sectionId) {
            this.setState({ selectSectionMessage: true })
            return false
        }

        if (!payload.chapter) {
            this.setState({ selectChapterMessage: true })
            return false
        }

        if (!payload.concepts || payload.concepts.length == 0) {
            this.setState({ selectConceptMessage: true })
            return false
        }

        if (payload.type === 'ADAPTIVE_CLASSWORK' || payload.type === 'ADAPTIVE') {

            for (let i = 0; i < payload.categories.length; i++) {
                let item = payload.categories[i]
                if (!item?.selectedElo || !item?.selectedElo?.length) {
                    this.setState({ selectEloMessage: true })
                    return false
                }
            }
        }

        // if (!payload.dueDate) {
        //     this.setState({ selectDueDateMessage: true })
        //     return false
        // }

        return true

    }

    onClickCreateDiganosticAssessment() {


        if (!this.state.questions.length) {
            console.log(this.state.questions)
            return
        }

        this.setState({ isCreate: true })

        let type = 'CLICKER_CONCEPT_CARD_WITH_ASSESSMENT'
        if (this.saving) return
        let payload = {
            ...this.state.payload,
            type: type ? type : this.props.type
        }
        payload.approximateQuestions = this.state.questionCount || 0
        payload.approximateTime = this.state.approximateTime || 0

        payload.questions = this.getQuestionPayload(this.state.questions || [])
        let validation = this.validatePayloadForDiagnosticAssessment(payload)

        console.log('clicked Create', validation)

        if (!validation) {
            this.setState({ isCreate: false, isLoading: false })
            return
        }

        this.setState({ isLoading: true })

        if (!this.state.studentListLength) {
            console.log('No Students having Roll Number')
            alert("No Students Found with Roll Number")
            return;
        }

        TestApi.createJigyasaAssessment(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false, showPickQuestions: false })
            let assessment = { ...response.data, ...payload, created: true }
            if (!assessment.totalUsers) {
                this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(assessment, "WHATSAPP")
            } else {
                this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(assessment)
                // this.props?.delegate?.showSuccessMessage && this.props.delegate.showSuccessMessage()
            }
            if (assessment.point) {
                this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(assessment.point)
            }
            this.props?.delegate?.hideNewHomework && this.props.delegate.hideNewHomework(true)
        }).catch(err => {

            this.saving = false

            this.setState({ isLoading: false })
        })

    }

    validatePayloadForDiagnosticAssessment(payload, leaveQuestions) {

        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID && !payload.subSubjectId) {
            this.setState({ errMessage: "Please Select the Subject" })
            return false
        }

        // if (this.user.subjectId === Constants.SCIENCE_SUBJECTID &&
        //     !payload.clickerAssessmentTitle && payload.subSubjectId.length > 1) {
        //     this.setState({ errMessage: "Please Enter Clicker Assessment title" })
        //     return false
        // }

        if (!payload?.board) {
            this.setState({ errMessage: "Please Select the Board" })
            return false
        }

        // if (!payload?.schoolId) {
        //     this.setState({ selectSchoolMessage: true })
        //     return false
        // }

        if (!payload?.class) {
            this.setState({ errMessage: "Please Select the Class" })
            return false
        }

        if (!payload.section) {
            this.setState({ errMessage: "Please Select the Section" })
            return false
        }



        // if (!payload.duration) {
        //     this.setState({ errMessage: "Please Select the Duration" })
        //     return false
        // }

        // if (!payload.dueDate && payload.type != Constants.CLICKER_ASSESSMENT) {
        //     this.setState({ selectedDueDateMessage: true })
        //     return false
        // }

        // if (!payload.medium) {
        //     this.setState({ selectedMediumMessage: true })
        //     return false
        // }



        if (!payload?.questions?.length) {
            this.setState({ errMessage: "No Questions Available" })
            return false
        }

        this.setState({ errMessage: "" })
        return true
    }

    getQuestionPayload(questions) {
        let result = questions.map(item => {
            item.mark = item?.content?.mark || CommonUtils.getMarkByComplexity(item?.content?.complexity)
            item.duration = item.duration
            delete item.content
            return item
        })
        if (this.state.selectedContentAssessment) {
            let contentIdList = []

            for (let key in this.state.contentsHash) {
                let item = this.state.contentsHash[key]
                if (item.selected) {
                    contentIdList.push(key)
                }
            }

            let filtered = questions.filter(item => contentIdList.includes(item.id))

            console.log(filtered)

            filtered.forEach(item => {
                if (this.state.contentsHash[item.id]) {
                    item.duration = this.state.contentsHash[item.id].duration
                }
            })

            result = filtered
        }

        return result
    }



    onClickBack = () => {

        // console.log(this.props.delegate.props.delegate.props.location.state)
        if (this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.from === "LEARNING_RESOURCES") {
            this.props.delegate.props.delegate.props.history.push({ pathname: Path.LEARNING_RESOURCES, state: { ...this.props.delegate.props.delegate.props.location.state.homeworkAssignPayload, from: 'NEW_HOMEWORK_CREATION' } })
        } else if (this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.from === 'RECOMMANDATION_REPORT') {
            this.props.delegate.props.delegate.props.history.push({ pathname: Path.PERSONALISED_CLASS_WORK, state: { ...this.props.delegate.props.delegate.props.location.state.homeworkAssignPayload, from: 'NEW_HOMEWORK_CREATION' } })
        } else {
            this.props?.delegate?.hideNewHomework && this.props.delegate.hideNewHomework()
        }
    }

    onClickInfo = () => {
        this.setState({ showInfoModal: true })
    }

    hideInfoModal = () => {
        this.setState({ showInfoModal: false })
    }

    onClickQuestionList = (categories, index) => {

        //console.log("Categories", categories)

        if (categories) {
            let selectedCategoryElos = categories[index].selectedElo

            this.getEloDetails(selectedCategoryElos, index)

            setTimeout(() => {
                this.setState({ showQuestionList: true, categories, selectedIndex: index })
            }, 200)
        } else {
            this.setState({ showQuestionList: true })
        }
    }

    hideQuestionList = () => {
        this.setState({ showQuestionList: false })
    }

    setSelectedQuestions = (selectedContent, value) => {
        console.log(selectedContent, value)

        const element = document.getElementById("CLICKER_PRACTICE_FILTER");
        console.log(element)

        this.hideQuestionList()
        if (selectedContent && selectedContent.selectedContentAssessment) {


            this.setState({
                ...selectedContent
            })
        }

        let questionCount = 0, approximateTime = 0
        if (value) {
            // this.onRefreshLOFilter(this.state.selectedFilter)


            element.scrollIntoView({ behavior: "instant", block: 'center' })
            this.showToaster('info', "Selected Questions have been applied")

            // this.getEloDetails()
        }

        if ((!selectedContent.selectAll && !selectedContent.questionCount)) {
            this.setState({ selectedElo: [], reloadEloDropdown: true }, () => {
                this.setState({ reloadEloDropdown: false })
            })
        }

        if (selectedContent.selectAll && selectedContent.selectedElo && selectedContent.selectedElo.length) {
            this.setState({ selectedElo: selectedContent.selectedElo, reloadEloDropdown: true }, () => {
                this.setState({ reloadEloDropdown: false })
            })
        }



    }

    onClickMenu = () => {
        this.setState({ showReport: true })
    }

    onDragStart = (event, dragInfo) => {

        event.target.style.cursor = 'cursor';
        event.stopPropagation();
        this.dragStartInfo = dragInfo;
        this.setState({ dragStartIndex: dragInfo.index })
    };

    onDragEnd = (event) => {
        event.target.style.cursor = 'cursor';
        this.setState({ dragStartIndex: null })
        let categories = this.state.categories
        if (this.dragOverInfo.type === this.dragStartInfo?.category?.type) return

        let dragFrom, dragTo

        for (let i = 0; i < categories.length; i++) {
            if (categories[i].type == this.dragStartInfo?.category?.type) {
                dragFrom = {
                    category: categories[i],
                    index: i
                }
            }
            if (categories[i].type == this.dragOverInfo?.type) {
                dragTo = {
                    category: categories[i],
                    index: i
                }
            }
            if (dragFrom && dragTo) break
        }

        if (dragFrom && dragTo) {
            let dragFromStudents = dragFrom.category.students
            dragFromStudents.splice(this.dragStartInfo?.index, 1)
            dragFrom.students = dragFromStudents

            if (dragTo.category.students) {
                dragTo.category.students.unshift(this.dragStartInfo.student)
            }

            categories[dragFrom.index] = dragFrom.category
            categories[dragTo.index] = dragTo.category
            this.setState({ categories, dragStartIndex: null })
        }

    }

    onDragOver = (event, cardInfo) => {
        event.preventDefault(); //allow drop here
        this.dragOverInfo = cardInfo
    }

    showConceptDetail = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideInfoModal} size={'lg'}>
                <ModalBody >
                    <ConceptDetail back={this.hideInfoModal} payload={this.state.payload} delegate={this} conceptsInfo={this.state.conceptsInfo} chapterTitle={this.state.selectedChapterTitle} chapterKey={this.state.selectedChapterKey} conceptTitles={this.state.selectedConceptsName} />
                </ModalBody>
            </Modal>
        )

    }

    showQuestionList = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                <ModalBody >
                    <QuestionListFromHomework back={this.hideQuestionList} contents={this.state.contents}
                        contentsHash={this.state.selectedContentAssessment ? this.state.contentsHash : {}}
                        questionSelection={this.state.questionSelection}
                        questionCount={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].questionCount : (this.state.questionCount || 0)}
                        approximateTime={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].approximateTime : (this.state.approximateTime || 0)}
                        showTimer={this.state.payload.showTimer}
                        eloDropdownItems={this.state.payload}
                        isAdaptive={this.state.isAdaptive}
                        skillDropdownItems={this.state.payload.skillDropdownItems}
                        isFromDraft={this.props.isFromDraft} />
                </ModalBody>
            </Modal>
        )
    }

    onSelectElo = (options, index, selectedFilter) => {

        //console.log(options, index, selectedFilter)

        let groupByConcept = {}
        let conceptList = []

        let groupBySkill = {}


        for (let i = 0; i < options.length; i++) {
            let option = options[i]

            if (!groupByConcept[option?.conceptValue])
                groupByConcept[option.conceptValue] = { key: option.conceptValue, elos: [{ id: option?.value }] }
            else
                groupByConcept[option.conceptValue].elos.push({
                    id: option?.value
                })

            if (!groupBySkill[option?.skill]) {
                groupBySkill[option.skill] = { key: option.skill, elos: [option?.value] }
            } else {

                if (groupBySkill[option.skill].elos.includes(option?.value)) {
                    let index = groupBySkill[option.skill].elos.findIndex(ele => ele === option?.value)
                    groupBySkill[option.skill].elos.splice(index, 1)
                }
                else {
                    groupBySkill[option.skill].elos.push(option?.value)
                }
            }
        }

        let skillWiseSelectedOptionsCountHash = {}

        let skillsArray = Object.keys(groupBySkill)

        skillsArray.forEach(skill => {

            skillWiseSelectedOptionsCountHash[skill] = groupBySkill[skill].elos.length
        })





        let conceptKeys = []

        for (let i = 0; i < this.state.conceptsArray.length; i++) {

            conceptKeys.push(this.state.conceptsArray[i].key)

        }

        for (let i = 0; i < conceptKeys.length; i++) {

            let key = conceptKeys[i]
            if (groupByConcept[key]) {
                conceptList.push({
                    key,
                    elos: groupByConcept[key].elos
                })
            }
        }

        let values = options.map(option => option?.value)




        let categories = this.state.categories
        categories[index].selectedElo = values
        categories[index].conceptList = conceptList
        categories[index].selectedFilter = selectedFilter
        categories[index].skillWiseSelectedOptionsCountHash = skillWiseSelectedOptionsCountHash

        this.setState({ categories })
        this.getEloDetails(values, index)
    }


    onSelectDropDown(option, cardInfo, index) {

        let selectedElos = cardInfo.selectedElos || []

        if (selectedElos.includes(option?.value)) {
            selectedElos = selectedElos.filter(item => item !== option?.value)
        } else {
            selectedElos.push(option?.value)
        }

        cardInfo.selectedElos = selectedElos
        let categories = this.state.categories
        categories[index] = cardInfo
        this.setState({ categories })
    }



    handleFilter = (payload, refreshStudent, isReloadQuestions) => {
        console.log(payload, isReloadQuestions)
        this.setState({ payload }, () => {
            if (isReloadQuestions) {
                this.setState({ contents: [], questionCount: 0, approximateTime: 0, availabeSets: [], selectedSet: [] })
            }
            refreshStudent && this.getStudents()

            if (payload.revisionType === Constants.REVISION_WITH_ASSESSMENT) { // For Clicker Assessment
                this.getQuestionList()
            } else {
                if (isReloadQuestions) {
                    this.getChapterHierarchy()
                }
                this.getStandardHomeworkList()

                if (this.props.type === 'ADAPTIVE_CLASSWORK' && payload.concepts) {

                    let levelArray = []
                    let categories = this.state.categories

                    payload = {
                        class: this.state.payload?.class,
                        board: this.state.payload?.board,
                        selectedChapter: this.state.payload?.pkChapterKey ? this.state.payload?.pkChapterKey : this.state.payload?.chapter,
                        // status: "ONBOARDED"
                    }

                    if (this.state.payload?.assignFrom === "REMEIDAL_REPORT") {
                        payload.assignFrom = "REMEIDAL_REPORT"
                    }


                    HomeworkApi.getChapterHierarchy(payload)
                        .then(response => {

                            // console.log("response", response)

                            let conceptsName = []

                            this.storeConceptDetails(response.chapter)

                            let conceptsHash = {}

                            for (let i = 0; i < response.chapter.length; i++) {

                                conceptsHash[response.chapter[i].conceptKey] = response.chapter[i]

                            }

                            for (let i = 0; i < response.chapter.length; i++) {
                                conceptsName.push(response.chapter[i].title)
                            }

                            if (response.chapter.length) {
                                this.setState({ conceptsInfo: response.chapter, selectedChapterTitle: response.chapter[0].chapterTitle, selectedChapterKey: response.chapter[0].chapterKey, selectedConceptsName: conceptsName, reloadDropdown: true }, () => {
                                    this.setState({ reloadDropdown: false })
                                })
                            }

                            for (let i = 0; i < payload.concepts.length; i++) {

                                let concept = conceptsHash[payload.concepts[i]]
                                for (let i = 0; i < concept.elos.length; i++) {
                                    levelArray.push({ title: `Start from level ${i + 1}`, value: i + 1 })
                                }
                                if (concept.elos.length === 1) {

                                    for (let i = 0; i < categories.length; i++) {
                                        categories[i].selectedCriterion = 1
                                    }

                                } else if (concept.elos.length === 2) {

                                    for (let i = 0; i < categories.length; i++) {
                                        if (categories[i].type === "NOVICE") {
                                            categories[i].selectedCriterion = 1
                                        } else {
                                            categories[i].selectedCriterion = 2
                                        }

                                    }

                                } else {
                                    for (let i = 0; i < categories.length; i++) {
                                        categories[i].selectedCriterion = i + 1
                                    }
                                }
                            }

                            this.setState({ criterionDropdownItems: levelArray, reloadDropdown: true, categories }, () => {
                                this.setState({ reloadDropdown: false })
                            })

                        }).catch(err => {
                            console.log("err", err)
                        })

                }
            }

        })

    }

    getQuestionList(payload = {}) {

        payload.chapterKey = this.state.payload?.chapter
        payload.class = this.state.payload?.class
        payload.duration = this.state.payload?.duration

        console.log(payload)

        // if (this.props.type === 'CLICKER_ASSESSMENT') {
        payload.type = 'CLICKER_ASSESSMENT'
        // }

        if (payload.chapterKey?.length > 1 && this.state.payload.questionCount) {
            payload.questionCount = this.state.payload.questionCount
        }

        if (!payload.chapterKey?.length) {
            console.log(payload)
            this.setState({
                isLoading: true, questions: [], questionCount: 0,
                approximateTime: 0,
                contents: []
            }, () => {
                this.setState({ isLoading: false })
            })
            return
        }

        if (payload.chapterKey?.length > 1 && !payload.questionCount) {
            this.setState({ questions: [], approximateTime: null })
            return
        }

        if (this.state.showCompetencyQuestionsOnly) {
            payload.showCompetencyQuestionsOnly = true
        }



        payload.chapterKey = payload.chapterKey.join(",")

        if (this.state.payload?.selectedQuestionSetId) {
            payload.selectedQuestionSetId = this.state.payload?.selectedQuestionSetId
        }

        this.setState({ isLoading: true, questions: [] })

        // if (this.props.type === "DIAGNOSTIC") {
        //     TestApi.getDiagnosticQuestionList(payload)
        //         .then(response => {

        //             this.setState({ questions: response?.questions, isLoading: false })
        //         }).catch(err => {
        //             this.setState({ isLoading: false, questions: [] })
        //         })
        // } else {
        TestApi.getAssessmentQuestionList(payload)
            .then(response => {
                if (response.questions && response.questions.length > 0) {
                    response.questions.map(question => {
                        if (!question.mandatoryAttachments) {
                            question.mandatoryAttachments = {
                                video: false,
                                audio: false,
                                image: false
                            }
                        }
                        return question
                    })
                }
                this.setState({
                    questions: response?.questions, contents: response?.questions,
                    isLoading: false, approximateQuestions: response?.questions.length,
                    questionCount: response?.questions.length,
                    approximateTime: response.approximateTime
                }, () => {
                    this.changeTab({ value: 2 })
                })
            }).catch(err => {
                this.setState({
                    isLoading: false, questions: [], questionCount: 0,
                    approximateTime: 0,
                    contents: []
                })
            })
        // }
    }

    getChapterHierarchy(payload = {}) {

        if (!this.state.payload || !this.state.payload.chapter) {
            this.setState({
                questionCount: 0,
                contents: [],
                // approximateTime: response.questionCount, //ask by ravi
                // reloadQuestions: false,
                approximateTime: 0, //ask by ravi
                selectSingleQuestionFromElo: false,
                // questionSelection: true,
                isLoading: false,
                cEloIds: [],
                showNumberOfAssessmentCreationpopup: false,
                mapContentIdToConcept: {}
            })
            return
        }

        if (this.state.payload.chapter && (this.props.type === 'CLICKER_PRACTICE_STANDARD' || this.props.type === Constants.CLICKER_CONCEPT_CARD)) {
            // this.getEloDetails()
        } else {
            this.getHomeworkQuestionCategory()
        }

        // console.log(this.state.payload)

        if (this.state.payload?.conceptDropownItems && this.state.payload?.conceptDropownItems.length && !this.state.payload?.assignFrom) {
            this.onMultiSelectDropdown(this.state.payload?.conceptDropownItems, 'selectedConcept')
        } else if (this.state.payload?.conceptDropownItems && this.state.payload?.conceptDropownItems.length &&
            this.state.payload?.concepts && this.state.payload?.concepts?.length && this.state.payload?.assignFrom) {
            let conceptDropownItems = this.state.payload?.conceptDropownItems.filter(item => this.state.payload?.concepts.includes(item.value))
            this.onMultiSelectDropdown(conceptDropownItems, 'selectedConcept')
        }


        payload = {
            class: this.state.payload?.class,
            board: this.state.payload?.board,
            selectedChapter: this.state.payload?.pkChapterKey ? this.state.payload?.pkChapterKey : this.state.payload?.chapter,
            // status: "ONBOARDED"
            // type: 'WORKSHEET'
        }

        if (this.state.payload?.assignFrom === "REMEIDAL_REPORT") {
            payload.assignFrom = "REMEIDAL_REPORT"
        }


        HomeworkApi.getChapterHierarchy(payload)
            .then(response => {

                // console.log("response", response)

                let conceptsName = []

                this.storeConceptDetails(response.chapter)

                for (let i = 0; i < response.chapter.length; i++) {
                    conceptsName.push(response.chapter[i].title)
                }
                this.setState({
                    conceptsInfo: response.chapter,
                    selectedChapterTitle: response.chapter[0].chapterTitle,
                    selectedChapterKey: response.chapter[0].chapterKey,
                    selectedConceptsName: conceptsName,
                    reloadDropdown: true
                }, () => {
                    this.setState({ reloadDropdown: false })
                })


            }).catch(err => {
                console.log("err", err)
            })
    }

    getHomeworkQuestionCategory() {

        let payload = {
            class: this.state.payload?.class,
            board: this.state.payload?.board,
            section: this.state.payload?.section,
            chapter: this.state.payload?.pkChapterKey ? this.state.payload?.pkChapterKey : this.state.payload?.chapter,
            concepts: this.state.payload.concepts ? this.state.payload.concepts : [],
            elos: (this.state.payload.elos ? this.state.payload.elos : []),
            conceptList: []
        }

        if (this.state.payload.conceptList && this.state.payload.conceptList.length) {
            payload.conceptList = this.state.payload.conceptList
        }

        HomeworkApi.homeworkQuestionCategory(payload).then(res => {
            // console.log(res.data)
            if (res.data && res.data.questionCategory) {
                this.setState({ questionCategory: res.data.questionCategory }, () => {
                    // this.getEloDetails()
                })
            }

        }).catch(err => {
            console.log(err)
        })
    }

    getStudents = (selectedHomework = '') => {
        let payload = {
            class: this.state.payload?.class,
            board: this.state.payload?.board,
            verified: true,
            rollNumber: true,
            isForQuiz: false
        }

        // if (this.state.payload?.section) {
        //     payload.section = this.state.payload?.section
        // }

        // console.log(this.state.payload.sectionId)

        if (this.state.payload?.sectionId) {
            payload.sectionId = this.state.payload?.sectionId
        }

        if (!payload.class || !payload.board) return
        this.setState({ isLoading: true })

        if (selectedHomework || this.state.payload?.homeworkId) {


            if (!this.state.payload?.assigningFrom) {
                payload.homeworkId = selectedHomework.value || this.state.payload?.homeworkId
                HomeworkApi.getHomeworkEvaluationReport(payload)
                    .then(response => {
                        //console.log(response)
                        let { noviceStudents: noviceStudents1, proficientStudents, advancedStudents, notCompletedStudents, basePath } = response
                        this.setState({ isLoading: false, basePath: basePath, showStudentToaster: true }, () => {
                            setTimeout(() => { this.hideToaster() }, 5000);
                        })


                        let noviceStudents = [...noviceStudents1, ...notCompletedStudents]

                        //console.log({ noviceStudents, proficientStudents, advancedStudents })

                        this.adaptiveHomeworkStudents({ noviceStudents, proficientStudents, advancedStudents })
                    })
                    .catch(err => {
                        this.setState({ isLoading: false })
                    })
            } else {
                console.log(payload)
                payload.testId = selectedHomework.value || this.state.payload?.homeworkId

                TestApi.getTestResultReport(payload)
                    .then(response => {
                        //console.log(response)
                        let { noviceStudents: noviceStudents1, proficientStudents, advancedStudents, notCompletedStudents, basePath } = response
                        this.setState({ isLoading: false, basePath: basePath, showStudentToaster: true }, () => {
                            setTimeout(() => { this.hideToaster() }, 5000);
                        })


                        let noviceStudents = [...noviceStudents1, ...notCompletedStudents]

                        //console.log({ noviceStudents, proficientStudents, advancedStudents })

                        this.adaptiveHomeworkStudents({ noviceStudents, proficientStudents, advancedStudents })
                    })
                    .catch(err => {
                        this.setState({ isLoading: false })
                    })
            }



        }
        else {
            SchoolUserApi.getSchoolUsers(payload)
                .then(response => {
                    //console.log(response)
                    this.setState({ isLoading: false, basePath: response.basePath })

                    if (this.props.type === 'ADAPTIVE_CLASSWORK') {
                        let noviceStudents = [], proficientStudents = [], advancedStudents = []
                        response = response?.response || []



                        for (let i = 0; i < response.length; i++) {
                            let previousYearMark = response[i]?.previousYearMark?.mark
                            if (!previousYearMark) {
                                let category = response[i].category

                                if (!category || category === "NOVICE") {
                                    noviceStudents.push(response[i])
                                } else if (category === "PROFICIENT") {
                                    proficientStudents.push(response[i])
                                } else {
                                    advancedStudents.push(response[i])
                                }

                            } else {
                                if (previousYearMark < 50) {
                                    noviceStudents.push(response[i])
                                } else if (previousYearMark >= 50 && previousYearMark <= 80) {
                                    proficientStudents.push(response[i])
                                } else {
                                    advancedStudents.push(response[i])
                                }
                            }
                        }
                        this.adaptiveHomeworkStudents({ noviceStudents, proficientStudents, advancedStudents })
                    } else {
                        this.standardHomeworkStudent(response?.response || [])
                    }

                }).catch(err => {
                    this.setState({ isLoading: false })
                })
        }
    }

    adaptiveHomeworkStudents = (response) => {
        let categories = this.state.categories

        for (let i = 0; i < categories.length; i++) {
            if (categories[i].title === 'NOVICE') {
                categories[i].students = response.noviceStudents

            } else if (categories[i].title === 'PROFICIENT') {
                categories[i].students = response.proficientStudents

            } else if (categories[i].title === 'ADVANCED') {
                categories[i].students = response.advancedStudents
            }
        }
        this.setState({ categories })
    }

    storeConceptDetails = (item) => {

        let conceptsHash = {}

        for (let i = 0; i < item.length; i++) {

            conceptsHash[item[i].conceptKey] = item[i]

        }
        this.setState({ conceptsHash: conceptsHash })
    }

    getEloDetails = (elos, index, concepts, selectedSet) => {

        console.log('index.......', index, concepts)
        if (this.props.type === 'CLICKER_PRACTICE_STANDARD' ||
            this.props.type === Constants.CLICKER_CONCEPT_CARD ||
            this.props.type === 'STANDARD_CLASSWORK' || this.state.isAdaptive) {
            let payload = {
                class: this.state.payload?.class,
                board: this.state.payload?.board,
                section: this.state.payload?.section,
                chapter: this.state.payload?.pkChapterKey ? this.state.payload?.pkChapterKey : this.state.payload?.chapter,
                concepts: concepts && concepts.length ? concepts : this.state.payload?.concepts ? this.state.payload.concepts : [],
                elos: elos || (this.state.payload?.elos ? this.state.payload.elos : []),
                showTimer: this.state.payload?.showTimer,
                homeworkType: [this.props.type],
                questionSource: 'QUESTION_SET',

            }

            if (this.state.isDurationSelected) {
                payload.questionCount = this.state.selectedDuration?.questionsCount
                payload.isDurationSelected = this.state.isDurationSelected
            }

            if (selectedSet && selectedSet.length && !this.state.selectedDuration?.value) {
                payload.selectedSet = this.state.selectedSet
            }

            // console.log(payload)

            if (!payload.class || !payload.board || !payload.chapter.length) {
                this.setState({
                    questionCount: 0,
                    contents: [],
                    // approximateTime: response.questionCount, //ask by ravi
                    reloadQuestions: false,
                    approximateTime: 0, //ask by ravi
                    selectSingleQuestionFromElo: false,
                    questionSelection: true,
                    isLoading: false,
                    cEloIds: [],
                    showNumberOfAssessmentCreationpopup: false,
                    mapContentIdToConcept: {}
                }, () => {
                    // this.setState({ reloadQuestions: true })
                    // this.changeTab({value : 2})
                })

                return
            }

            if (this.state.isAdaptive) {
                if (index === 0 || index === 1) {
                    payload.setType = 'BASIC'
                } else {
                    payload.setType = 'ADVANCED'
                }
            }

            if (this.state.showCompetencyQuestionsOnly) {
                payload.showCompetencyQuestionsOnly = true
            }

            if (this.state.payload.baseLineHomeworkId) {
                payload.baseLineHomeworkId = this.state.payload.baseLineHomeworkId
            } else {
                payload.baseLineHomeworkId = null
            }

            if (this.state.selectOneQuestionPerELO) {
                payload.selectSingleQuestionFromElo = this.state.selectOneQuestionPerELO
            }

            if (this.props.assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS' && (this.props.isFromDraft || this.props.isClonePractice)) {
                payload.assessmentQuestionType = this.props.assessmentQuestionType
                payload.contentsHash = Object.keys(this.props.contentsHash)
            }


            // console.log(this.state.payload)

            HomeworkApi.getHomeworkEloDetailsForClickerPractice(payload)
                .then(response => {
                    console.log(response)

                    let questionCount = 0, noQuestionSelected = true, approximateTime = 0

                    if (this.state.selectedContentAssessment && response.content.length) {

                        response.content.forEach(skill => {
                            if (skill.questions.length) {
                                skill.questions.forEach(item => {
                                    let key = skill.skill, mins = 0
                                    if (this.state.contentsHash && this.state.contentsHash[item._id] && this.state.contentsHash[item._id].selected) {
                                        questionCount += 1
                                        noQuestionSelected = false
                                        if (key === 'Knowledge') {
                                            mins = 1  // 1 min for one Question
                                        } else if (key === 'Calculation') {
                                            mins = 2 // 1.5 min for Each question
                                        } else if (key === 'Modelling') {
                                            mins = 3 // 2.5 min for Each Question
                                        } else if (key === 'Comprehension') {
                                            mins = 4 // 3.5 min for Each Question
                                        } else if (key === 'Conceptual Understanding') {
                                            mins = 1 // // 1 min for Each Question
                                        }
                                        else if (key === 'Analytical Reasoning & Interpretation') {
                                            mins = 2 // 2 min for Each Question
                                        }
                                        else if (key === 'Visualization & Representation') {
                                            mins = 2.5 // 2.5 min for Each Question
                                        }
                                        else if (key === 'Mathematical Application') {
                                            mins = 3 // 3 min for Each Question
                                        } else if (key === 'Application to Practical Skills') {
                                            mins = 1.5 // 1.5 min for Each Question
                                        }
                                        approximateTime += mins
                                    }
                                })
                            }
                        });



                        if (noQuestionSelected) {
                            questionCount = response.questionCount
                            approximateTime = response.approximateTime
                        }
                    }

                    if (this.state.isAdaptive && elos?.length) {
                        let categories = this.state.categories
                        categories[index].questionCount = response.questionCount
                        // categories[index].approximateTime = response.questionCount
                        categories[index].approximateTime = response.approximateTime
                        categories[index].selectSingleQuestionFromElo = response.selectSingleQuestionFromElo
                        let contentsHash = {}

                        response.content.forEach(item => {
                            if (item.questions.length) {
                                item.questions.forEach(question => {
                                    contentsHash[question._id] = { contentId: question._id, eloId: question.eloId, selected: true }
                                })
                            }
                        })
                        categories[index].contentsHash = contentsHash
                        this.setState({
                            categories,
                            contents: response.content,
                            isLoading: false
                        })
                    } else {
                        // this.setState({
                        //     questionCount: response.questionCount,
                        //     contents: response.content,
                        //     // approximateTime: response.questionCount, //ask by ravi
                        //     approximateTime: response.approximateTime, //ask by ravi
                        //     selectSingleQuestionFromElo: response.selectSingleQuestionFromElo,
                        //     isLoading: false
                        // })
                        // if (!this.state.selectedContentAssessment) {
                        let setsList = []
                        if (response.availabeSetsList && response.availabeSetsList.length) {
                            response.availabeSetsList.forEach(item => {
                                setsList.push({ title: `Set ${item}`, value: item })
                            })
                        }

                        console.log(setsList)

                        this.setState({
                            questionCount: this.state.selectedContentAssessment ? questionCount : response.questionCount,
                            contents: response.content,
                            setsCovered: response.setsCovered,
                            availabeSets: setsList,
                            // approximateTime: response.questionCount, //ask by ravi
                            approximateTime: this.state.selectedContentAssessment ? approximateTime : response.approximateTime, //ask by ravi
                            // selectSingleQuestionFromElo: response.selectSingleQuestionFromElo,
                            questionSelection: response.questionSelection,
                            isLoading: false,
                            reloadQuestions: false,
                            // cEloIds: response.cEloIds && response.cEloIds.length ? response.cEloIds : [],
                            // showNumberOfAssessmentCreationpopup: response.showNumberOfAssessmentCreationpopup ? true : false,
                            // mapContentIdToConcept: response.mapContentIdToConcept
                        }, () => {
                            this.setState({ reloadQuestions: true })
                            // this.changeTab({value : 2})
                        })
                        // }
                    }
                }).catch(err => {
                })

        } else {
            let payload = {
                class: this.state.payload?.class,
                board: this.state.payload?.board,
                section: this.state.payload?.section,
                chapter: this.state.payload?.pkChapterKey ? this.state.payload?.pkChapterKey : this.state.payload?.chapter,
                concepts: this.state.payload?.concepts ? this.state.payload.concepts : [],
                elos: elos || (this.state.payload?.elos ? this.state.payload.elos : []),
                homeworkType: [this.props.type],
                questionSource: 'QUESTION_SET',
            }

            if (this.state.questionCategory) {
                payload.questionCategory = this.state.questionCategory
            }

            if (this.state.selectOneQuestionPerELO) {
                payload.selectSingleQuestionFromElo = this.state.selectOneQuestionPerELO
            }

            if (payload.class === 'Class 10') {
                payload.assessmentQuestionType = this.state.payload.assessmentQuestionType
                payload.questionCategory = this.state.payload?.questionCategory
            }

            if (this.state.showCompetencyQuestionsOnly) {
                payload.showCompetencyQuestionsOnly = true
            }

            if (this.state.isAdaptive) {
                payload.questionCategory = 'M2'
                payload.isAdaptive = true
            }


            if (!payload.class || !payload.board || !payload.chapter.length) {
                this.setState({
                    questionCount: 0,
                    contents: [],
                    // approximateTime: response.questionCount, //ask by ravi
                    reloadQuestions: false,
                    approximateTime: 0, //ask by ravi
                    selectSingleQuestionFromElo: false,
                    questionSelection: true,
                    isLoading: false,
                    cEloIds: [],
                    showNumberOfAssessmentCreationpopup: false,
                    mapContentIdToConcept: {}
                }, () => {
                    // this.setState({ reloadQuestions: true })
                    // this.changeTab({value : 2})
                })

                return
            }

            HomeworkApi.getHomeworkEloDetails(payload)
                .then(response => {
                    console.log(response, this.state.isAdaptive, elos?.length)
                    if (this.state.isAdaptive && elos?.length) {
                        let categories = this.state.categories
                        categories[index].questionCount = response.questionCount
                        // categories[index].approximateTime = response.questionCount
                        categories[index].approximateTime = response.approximateTime
                        categories[index].selectSingleQuestionFromElo = response.selectSingleQuestionFromElo

                        let contentsHash = {}

                        response.content.forEach(item => {
                            if (item.questions.length) {
                                item.questions.forEach(question => {
                                    contentsHash[question._id] = true
                                })
                            }
                        })
                        categories[index].contentsHash = contentsHash
                        this.setState({
                            categories,
                            contents: response.content,
                            isLoading: false,
                            questionSelection: false

                        })
                    } else {

                        let questionCount = 0, noQuestionSelected = true, approximateTime = 0

                        if (this.state.selectedContentAssessment && response.content.length) {

                            response.content.forEach(skill => {
                                if (skill.questions.length) {
                                    skill.questions.forEach(item => {
                                        let key = skill.skill, mins = 0
                                        if (this.state.contentsHash && this.state.contentsHash[item._id] && this.state.contentsHash[item._id].selected) {
                                            questionCount += 1
                                            noQuestionSelected = false
                                            if (key === 'Knowledge') {
                                                mins = 1  // 1 min for one Question
                                            } else if (key === 'Calculation') {
                                                mins = 2 // 1.5 min for Each question
                                            } else if (key === 'Modelling') {
                                                mins = 3 // 2.5 min for Each Question
                                            } else if (key === 'Comprehension') {
                                                mins = 4 // 3.5 min for Each Question
                                            } else if (key === 'Conceptual Understanding') {
                                                mins = 1 // // 1 min for Each Question
                                            }
                                            else if (key === 'Analytical Reasoning & Interpretation') {
                                                mins = 2 // 2 min for Each Question
                                            }
                                            else if (key === 'Visualization & Representation') {
                                                mins = 2.5 // 2.5 min for Each Question
                                            }
                                            else if (key === 'Mathematical Application') {
                                                mins = 3 // 3 min for Each Question
                                            } else if (key === 'Application to Practical Skills') {
                                                mins = 1.5 // 1.5 min for Each Question
                                            }
                                            approximateTime += mins
                                        }
                                    })
                                }
                            });



                            if (noQuestionSelected) {
                                questionCount = response.questionCount
                                approximateTime = response.approximateTime
                            }
                        }

                        // if (!this.state.selectedContentAssessment) {
                        this.setState({
                            questionCount: this.state.selectedContentAssessment ? questionCount : response.questionCount,
                            contents: response.content,
                            // approximateTime: response.questionCount, //ask by ravi
                            reloadQuestions: false,
                            approximateTime: this.state.selectedContentAssessment ? approximateTime : response.approximateTime, //ask by ravi
                            selectSingleQuestionFromElo: response.selectSingleQuestionFromElo,
                            questionSelection: response.questionSelection,
                            isLoading: false,
                            cEloIds: response.cEloIds && response.cEloIds.length ? response.cEloIds : [],
                            showNumberOfAssessmentCreationpopup: response.showNumberOfAssessmentCreationpopup ? true : false,
                            mapContentIdToConcept: response.mapContentIdToConcept
                        }, () => {
                            this.setState({ reloadQuestions: true })
                            // this.changeTab({value : 2})
                        })
                        // }
                    }
                }).catch(err => {
                })
        }
    }



    showCompetencyQuestionsOnly(showCompetency) {
        this.setState({ showCompetencyQuestionsOnly: showCompetency }, () => {
            this.getEloDetails()
        })

    }


    hideToaster() {
        this.setState({
            showStudentToaster: false
        });
    }


    getStandardHomeworkList() {
        // Chapter Based Standard Homework listing as per Ravi 
        let payload = {
            board: this.state.payload?.board,
            class: this.state.payload?.class,
            section: this.state.payload?.section,
            sectionId: this.state.payload?.sectionId,
            chapter: this.state.payload?.chapter,
            //concepts: this.state.payload?.concepts,
            allHomeworkList: "ALL_HOMEWORK_LIST"
        }



        if (!payload.board || !payload.class) return;

        if (!payload.chapter) return
        HomeworkApi.getHomework(payload)
            .then(response => {
                // console.log(response)
                let responseData = response.response
                //let homeworksList = [{title : "Chapter 1", value : 1}, {title : "Chapter 2", value : 2}, {title : "Chapter 3", value : 3}]
                this.buildHomeworkList(responseData)
            })
            .catch(err => {
                this.setState({ homeworkDropdownItems: [] })
                this.reloadDropdown()
            })

    }


    buildHomeworkList(homeworks) {
        let homeworkGroup = {}, individualHomework = []
        let homeworkList = []
        let allHomeworkList = []
        let allHomeworkListHash = {}
        for (let i = 0; i < homeworks.length; i++) {
            let homework = homeworks[i]
            let obj = {
                _id: homework._id,
                createdDateTimestamp: homework.countingwellCreatedTimestamp || homework.createdDate,
                createdDate: new Date(homework.countingwellCreatedTimestamp || homework.createdDate).toLocaleDateString("en-IN"),
                dueDate: new Date(homework.endDate).toLocaleDateString("en-IN"),
                chapter: homework?.chapter?.title,
                concepts: homework?.chapter?.concept,
                section: homework.section,
                class: homework.class,
                board: homework.board,
                completed: homework.completed,
                notCompleted: homework.notCompleted,
                status: homework.status,
                conceptBuild: homework?.chapter?.conceptBuild,
                notificationCount: homework?.notificationCount || 0,
                lastNotificationSentDate: homework?.lastNotificationSentDate,
                approximateQuestions: homework?.approximateQuestions,
                approximateTime: homework?.approximateTime,
                category: homework?.category,
                users: homework?.users || []
            }

            if (homework.groupId) {
                if (homeworkGroup[homework.groupId]) {
                    homeworkGroup[homework.groupId].push(obj)
                } else {
                    homeworkGroup[homework.groupId] = [obj]
                }
            } else {
                individualHomework.push(obj)
                allHomeworkListHash[homework._id.toString()] = obj
            }


            allHomeworkList.push({

                title: `Homework Created on ${CommonUtils.datePipe(homework.createdDate, false)}`,
                chapterTitle: homework.chapter.title,
                value: homework._id.toString(),
            })


        }

        let groupedHomework = Object.values(homeworkGroup)
        //console.log(allHomeworkListHash)

        homeworkList.push(...groupedHomework, ...individualHomework)

        this.setState({ homeworkList, homeworkDropdownItems: allHomeworkList, allHomeworkListHash, reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })

    }




    resetErrorMessages = () => {
        this.setState({ selectBoardMessage: false, selectChapterMessage: false, selectClassMessage: false, selectConceptMessage: false, selectSectionMessage: false, selectDueDateMessage: false, selectStreamingLogic: false })
    }

    standardHomeworkStudent(studentList = []) {
        let list = []

        // console.log(studentList)

        for (let i = 0; i < studentList.length; i += 3) {
            let students = studentList.slice(i, i + 3)
            list.push(students)
        }

        if (!list.length) {
            this.setState({ studentList: list, noStudentsFound: true, studentListLength: studentList.length })
        } else {
            this.setState({ studentList: list, noStudentsFound: false, studentListLength: studentList.length })
        }
    }

    handleEloDropdown = (eloDropdownItems, skillDropdownItems, conceptList) => {
        console.log(conceptList, eloDropdownItems, skillDropdownItems)

        this.setState({ eloDropdownItems, skillDropdownItems, conceptList, conceptsArray: conceptList, reloadDropdown: true }, () => {

            if (eloDropdownItems?.length && this.user.subjectId === Constants.MATHS_SUBJECTID) {

                let noviceElo = [], proficientElo = [], advancedElo = [], noviceSelectedSkill = "", proficientSelectedSkill = "", advancedSelectedSkill = ""
                eloDropdownItems.forEach(element => {
                    if (element.skill == "Knowledge") {
                        noviceElo.push(element)
                    } else if (element.skill == "Calculation") {
                        proficientElo.push(element)
                    } else {
                        advancedElo.push(element)
                    }

                })


                if (noviceElo.length) {
                    this.onSelectElo(noviceElo, 0, ["Knowledge"])
                } else if (proficientElo.length) {
                    this.onSelectElo(proficientElo, 0, ["Calculation"])
                }
                else if (advancedElo.length) {
                    this.onSelectElo(advancedElo, 0, ["Modelling", "Comprehension"])
                }

                setTimeout(() => {
                    if (proficientElo.length) {
                        this.onSelectElo(proficientElo, 1, ["Calculation"])
                    } else if (advancedElo.length) {
                        this.onSelectElo(advancedElo, 1, ["Modelling", "Comprehension"])
                    }
                    else if (noviceElo.length) {
                        this.onSelectElo(noviceElo, 1, ["Knowledge"])
                    }
                }, 300)



                setTimeout(() => {
                    if (advancedElo.length) {
                        this.onSelectElo(advancedElo, 2, ["Modelling", "Comprehension"])
                    } else if (proficientElo.length) {
                        this.onSelectElo(proficientElo, 2, ["Calculation"])
                    }
                    else if (noviceElo.length) {
                        this.onSelectElo(noviceElo, 2, ["Knowledge"])
                    }
                }, 600)


                setTimeout(() => {
                    this.setState({ reloadDropdown: true }, () => {
                        this.setState({ reloadDropdown: false })
                    })
                }, 2000)

            } else if (eloDropdownItems?.length && this.user.subjectId === Constants.SCIENCE_SUBJECTID) {

                let noviceElo = [], proficientElo = [], advancedElo = [], noviceSelectedSkill = "", proficientSelectedSkill = "", advancedSelectedSkill = ""
                eloDropdownItems.forEach(element => {
                    if (element.skill == "Conceptual Understanding") {
                        noviceElo.push(element)
                    } else if (element.skill == "Analytical Reasoning & Interpretation" || element.skill == "Visualization & Representation") {
                        proficientElo.push(element)
                    } else {
                        advancedElo.push(element)
                    }

                })


                if (noviceElo.length) {
                    this.onSelectElo(noviceElo, 0, ["Conceptual Understanding"])
                } else if (proficientElo.length) {
                    this.onSelectElo(proficientElo, 0, ["Analytical Reasoning & Interpretation", 'Visualization & Representation'])
                }
                else if (advancedElo.length) {
                    this.onSelectElo(advancedElo, 0, ["Mathematical Application", "Application to Practical Skills"])
                }

                setTimeout(() => {
                    if (proficientElo.length) {
                        this.onSelectElo(proficientElo, 1, ["Analytical Reasoning & Interpretation", 'Visualization & Representation'])
                    } else if (advancedElo.length) {
                        this.onSelectElo(advancedElo, 1, ["Mathematical Application", "Application to Practical Skills"])
                    }
                    else if (noviceElo.length) {
                        this.onSelectElo(noviceElo, 1, ["Conceptual Understanding"])
                    }
                }, 300)



                setTimeout(() => {
                    if (advancedElo.length) {
                        this.onSelectElo(advancedElo, 2, ["Mathematical Application", "Application to Practical Skills"])
                    } else if (proficientElo.length) {
                        this.onSelectElo(proficientElo, 2, ["Analytical Reasoning & Interpretation", 'Visualization & Representation'])
                    }
                    else if (noviceElo.length) {
                        this.onSelectElo(noviceElo, 2, ["Conceptual Understanding"])
                    }
                }, 600)


                setTimeout(() => {
                    this.setState({ reloadDropdown: true }, () => {
                        this.setState({ reloadDropdown: false })
                    })
                }, 1000)

            } else {

                let categories = this.state.categories

                categories.forEach(element => element.selectedElo = [])

                this.setState({ categories, reloadDropdown: false })
            }

        })
    }

    showHomeworkSelectionDropdown = () => {

        let checked = this.state.selectedHomeworkBasedStudentGrouping

        this.setState({ selectedHomeworkBasedStudentGrouping: !checked }, () => {
            //console.log(checked)
            if (checked == true) {
                this.getStudents()
            }
        })

        if (checked == false) {
            this.setState({ showToaster: true })
        }
    }


    hideMoreInfoModal = () => {
        this.setState({ showMoreInfo: false })
    }

    showHomeworkInfo = (item) => {
        // let homeworkList = this.state.homeworkList
        // homeworkList[index].expand = !homeworkList[index].expand

        let homework = this.state.allHomeworkListHash[item.value]
        this.setState({ showMoreInfo: true, selectedHomeworkMore: homework })
        //console.log(homework)
    }



    renderStudentCard = (student, category, index, draggable) => {
        return (

            <div className={`cw-card student ${draggable ? "drag-hand px-3 py-1" : "p-2"}`}
                onDragStart={(e) => this.onDragStart(e, { student, category, index })}
                onDragEnd={(e) => this.onDragEnd(e)}
                draggable={draggable}>
                {/* <>{
                     this.dragStartInfo?.category?.type === category?.type && this.state.dragStartIndex === index && draggable ?
                         <div className="drag-loading">
                             <img className='' src={getImageSource(ImageConstants.DRAG_LOADING)} />
                         </div>
                         : ""}
                 </> */}


                <div className={`flex align-items-center }`}>
                    {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                         <div className="row justify-content-center">
                             
                             {student.image ? <img className="" alt="img" src={`${this.state.basePath}${student.image}`} />
                                 :
                                 <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                         </div>
                     </div> */}
                    {draggable && <div className={`${draggable ? 'pl-2' : ''} drag-icon`}> <img className='cursor-pointer' src={getImageSource(ImageConstants.DRAG)} /></div>}
                    <div className="pl-2 d-inline-block">
                        <div className="student-name">{student?.name}</div>
                        {/* <div className="student-roll-number text-left">Roll no - {student?.rollNumber}</div> */}
                    </div>
                </div>
            </div>
        )
    }

    renderStandard = () => {
        return (
            <div id="table-scoll" className="table-responsive mt-8">
                <table className="table cw-table mb-0 align-items-center">
                    {/* <thead>
                        <tr>
                            <th colSpan="3" className='th-left-radius th-right-radius homework-text'>All Students {`${this.state.studentListLength ? `(${this.state.studentListLength})` : ''}`}</th>
                        </tr>
                    </thead> */}
                    <tbody className="bg-white">
                        {/* {
                            this.state.payload?.chapter?.length ?
                                <tr key={"1-row"} className="">

                                    <td className="table-row-1 mt-4 p-4"><span>Number of Questions</span> <b className="pl-3"> {this.state.questionCount || 0}</b></td>
                                    <td className="table-row-1  p-4"><span>Approximate Time</span> <b className="pl-3">{this.state.approximateTime || 0} </b>mins</td>
                                    <td>
                                        <div className="text-right">
                                            <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.HAMBARGUR)} onClick={() => this.onClickQuestionList()} />
                                        </div>
                                    </td>
                                </tr>
                                : <tr className="bg-white pt-4"><td colSpan="5" align='center'>Please select a Concept</td></tr>
                        } */}
                        {
                            this.state.studentList?.length ? this.state.studentList?.map(students => (
                                <tr key={Math.random()} className="">
                                    {
                                        students?.map((item, index) => (
                                            <td className="text-center p-3">{this.renderStudentCard(item)}</td>
                                        ))
                                    }
                                </tr>
                            ))
                                : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                        }
                    </tbody>
                </table>
            </div >
        )
    }

    changeTab(item) {

        if (item.value === 2) {
            // console.log(this.state.payload.elos)

            if (!this.state.payload?.eloDropdownItems) {
                return;
            }

            this.filterHash = {}
            for (let i = 0; i < this.state.payload.eloDropdownItems.length; i++) {
                let obj = this.state.payload.eloDropdownItems[i]

                let key = obj['skill']
                if (this.filterHash[key]) {
                    this.filterHash[key].push(obj)
                } else {
                    this.filterHash[key] = [obj]
                }
            }
            let dropDownoptions = this.state.payload.eloDropdownItems ? JSON.parse(JSON.stringify(this.state.payload.eloDropdownItems)) : []
            let skillWiseELOListHash = {}
            dropDownoptions.forEach(option => {
                if (!skillWiseELOListHash[option.skill]) {
                    skillWiseELOListHash[option.skill] = [option]
                } else {
                    skillWiseELOListHash[option.skill].push(option)
                }
            })

            let skillWiseELO = []
            let skills = Object.keys(skillWiseELOListHash)

            skills.forEach(skill => {

                skillWiseELO.push(skillWiseELOListHash[skill])

            })

            console.log(skillWiseELO)

            this.setState({ options: skillWiseELO })

            if (this.state.selectedFilter?.length) {
                let options = []
                this.state.selectedFilter.forEach(element => {
                    this.filterHash[element] && options.push(...this.filterHash[element])
                })
                // this.state.options = options
                this.setState({ options })
            }


            this.setState({ selectedElo: this.state.payload.elos, reloadEloDropdown: true }, () => {
                this.setState({ reloadEloDropdown: false })
            })
        }

        this.setState({ selectedTab: item.value })
    }

    reloadToSetSelectedElo = () => {
        // console.log()
        this.setState({ reloadEloDropdown: true }, () => {
            this.setState({ reloadEloDropdown: false })
        })
    }

    onSelectEloFromQuestionList = (options) => {
        let groupByConcept = {}
        let conceptList = []

        // for (let i = 0; i < options.length; i++) {
        //     let option = options[i]

        //     if (!groupByConcept[option?.conceptValue])
        //         groupByConcept[option.conceptValue] = { key: option.conceptValue, elos: [{ id: option?.value }] }
        //     else
        //         groupByConcept[option.conceptValue].elos.push({
        //             id: option?.value
        //         })
        // }



        let conceptKeys = [], chapters = {}

        // for (let i = 0; i < this.state.payload.conceptsArray.length; i++) {

        //     conceptKeys.push(this.state.conceptsArray[i].key)

        //     if (chapters[this.state.conceptsArray[i].chapterKey]) {
        //         if (groupByConcept[this.state.conceptsArray[i].key]) {
        //             chapters[this.state.conceptsArray[i].chapterKey].concept.push({
        //                 key: this.state.conceptsArray[i].key,
        //                 elos: groupByConcept[this.state.conceptsArray[i].key] ? groupByConcept[this.state.conceptsArray[i].key].elos : []
        //             })
        //         }
        //     } else {
        //         chapters[this.state.conceptsArray[i].chapterKey] = {
        //             key: this.state.conceptsArray[i].chapterKey,
        //             concept: []
        //         }
        //         if (groupByConcept[this.state.conceptsArray[i].key]) {
        //             chapters[this.state.conceptsArray[i].chapterKey].concept.push({
        //                 key: this.state.conceptsArray[i].key,
        //                 elos: groupByConcept[this.state.conceptsArray[i].key] ? groupByConcept[this.state.conceptsArray[i].key].elos : []
        //             })
        //         }
        //     }
        // }

        // console.log(chapters)
        // for (let i = 0; i < conceptKeys.length; i++) {

        //     let key = conceptKeys[i]
        //     if (groupByConcept[key]) {
        //         conceptList.push({
        //             key,
        //             elos: groupByConcept[key].elos
        //         })
        //     }
        // }

        let values = options.map(option => option?.value)
        // let result = []
        // for (let i = 0; i < this.state.orderedEloList?.length; i++) {
        //     let eloId = this.state.orderedEloList[i]?.elos[0]?.id
        //     if (values.includes(eloId)) {
        //         result.push(eloId)
        //     }
        // }

        let reloadEloDropdown = false

        // if (this.props.isFromDraft) {
        //     reloadDropdown = true
        // }

        // console.log(values)

        this.setState({ selectedElo: values, selectAll: values.length ? false : true, reloadEloDropdown }, () => {
            this.setState({ reloadEloDropdown: false })
            // this.emitChanges()
            this.getEloDetails(values)
        })
    }

    onClickFliter(item, isReload) {
        if (!item.value) return
        let value = item.value
        let selectedFilter = this.state.selectedFilter || []
        // if (item.value == selectedFilter) value = ""
        let options = []

        if (value) {
            // options = this.filterHash[value] || []

            if (selectedFilter.includes(value)) {
                selectedFilter = selectedFilter.filter(item => item != value)
            } else {
                selectedFilter.push(value)
            }

            selectedFilter.forEach(skill => {
                options.push(...this.filterHash[skill])
            })

        } else {
            let allOptions = Object.values(this.filterHash)
            if (allOptions) {
                allOptions.forEach(element => {
                    options.push(...element)
                })
            }

            selectedFilter = []
        }



        let skillWiseELOListHash = {}
        options.forEach(option => {
            if (!skillWiseELOListHash[option.skill]) {
                skillWiseELOListHash[option.skill] = [option]
            } else {
                skillWiseELOListHash[option.skill].push(option)
            }
        })

        let skillWiseELO = []
        let skills = Object.keys(skillWiseELOListHash)

        skills.forEach(skill => {

            skillWiseELO.push(skillWiseELOListHash[skill])

        })

        console.log(selectedFilter, options, skillWiseELO)

        // let reloadEloDropdown = true

        // // if(!isReload) {
        // //     reloadEloDropdown = false
        // // }

        this.setState({ options: skillWiseELO, selectedFilter, reloadEloDropdown: true, selectedSkill: item.value }, () => {
            this.setState({ reloadEloDropdown: false })
            this.onSelectEloFromQuestionList(options)
        })
        // this.props.onRefreshLOFilter(selectedFilter)
    }


    onSelectOneQuestionPerELO(value) {
        this.setState({ selectOneQuestionPerELO: !this.state.selectOneQuestionPerELO }, () => {

            if (!value) {
                this.onMultiSelectDropdown(this.state.availabeSets, 'selectedSet', true)
            } else {
                this.onMultiSelectDropdown([this.state.availabeSets[0]], 'selectedSet', true)
            }

        })
    }


    onMultiSelectDropdown = (options, key, isMannual = false) => {
        console.log(options, key)

        if (key == "selectedConcept") {
            if (this.state.isFromPk) {
                options = [{ value: this.state.pkConceptKey, order: 1 }]
            }

            this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()
            let value = [], eloDropdownItems = [], conceptList = [], skillDropdownItems = [], skillHash = {}, selectedElo = []
            options = options.sort((a, b) => a.order - b.order)
            // console.log(this.eloHash)

            for (let i = 0; i < options.length; i++) {
                let option = options[i]
                value.push(option?.value)

                // if (key == "selectedConcept") {
                //     if (this.eloHash[option?.value]) {
                //         console.log('selected Concept')
                //         let eloContruct = []
                //         let elo = this.eloHash[option?.value]
                //         let elos = elo.map((e) => {

                //             if (!skillHash[e.skill]) {
                //                 skillHash[e.skill] = true
                //                 skillDropdownItems.push({ title: e.skill, value: e.skill })
                //             }

                //             eloContruct.push({ id: e.value })

                //             selectedElo.push(e.value) // To Select All the Elo


                //             return {
                //                 ...e,
                //                 conceptName: `Concept ${i + 1}`
                //             }
                //         })
                //         eloDropdownItems.push(...elos)

                //         conceptList.push({
                //             key: option?.value,
                //             elos: eloContruct
                //         })
                //     }
                // }
            }
            // let selectedElo = eloDropdownItems.map(item => item.value)
            // console.log(value)

            // console.log(selectedElo)

            let reloadConceptDropdown = true

            if (isMannual) {
                reloadConceptDropdown = false
            }

            if (this.props.isFromDraft) {
                reloadConceptDropdown = true
            }
            this.setState({ reloadDropdown: true, reloadConceptDropdown, eloDropdownItems, skillDropdownItems, [key]: value, conceptList, conceptsArray: conceptList, selectedElo }, () => {
                // this.props.isAdaptive && key == "selectedConcept" && this.props.delegate?.handleEloDropdown && this.props.delegate.handleEloDropdown(eloDropdownItems, skillDropdownItems, conceptList)
                this.getEloDetails(null, null, value, this.state.selectedSet)
                if (this.props.isClonePractice && !isMannual) {
                    this.setState({ reloadDropdown: false, reloadConceptDropdown: false })
                } else if (isMannual) {
                    this.setState({ reloadDropdown: false })
                } else if (!isMannual) {
                    this.setState({ reloadDropdown: false, reloadConceptDropdown: false })
                }
            })
        }

        if (key === 'selectedSet') {
            let value = []

            for (let i = 0; i < options.length; i++) {
                let option = options[i]
                value.push(option?.value)
            }

            let reloadSetDropdown = false

            if (isMannual) {
                reloadSetDropdown = true
            }

            if (this.props.isFromDraft) {
                reloadSetDropdown = true
            }
            this.setState({ reloadDropdown: true, reloadSetDropdown, [key]: value }, () => {
                this.getEloDetails(null, null, this.state.selectedConcept, value)
                if (this.props.isClonePractice && !isMannual) {
                    this.setState({ reloadDropdown: false, reloadSetDropdown: false })
                } else if (isMannual) {
                    this.setState({ reloadDropdown: false, reloadSetDropdown: false })
                } else if (!isMannual) {
                    this.setState({ reloadDropdown: false, reloadSetDropdown: false })
                }
            })
        }
    }

    onSelectDuration(key, value) {
        if (this.state.selectedDuration?.value === value?.value) {
            this.setState({ [key]: {}, isDurationSelected: false, selectedSet: [], selectedContentAssessment: false }, () => {
                this.onMultiSelectDropdown(this.state.payload?.conceptDropownItems, 'selectedConcept')
            })
        } else {
            this.setState({ [key]: value, isDurationSelected: true, selectedSet: [], reloadSetDropdown: true, selectedContentAssessment: false }, () => {
                this.setState({ reloadSetDropdown: false })
                this.onMultiSelectDropdown(this.state.payload?.conceptDropownItems, 'selectedConcept')
            })
        }

    }

    resetFilter() {
        this.setState({ selectedDuration: {}, isDurationSelected: false, selectedSet: [], selectedContentAssessment: false, reloadSetDropdown: true }, () => {
            this.setState({ reloadSetDropdown: false })
            this.onMultiSelectDropdown(this.state.payload?.conceptDropownItems, 'selectedConcept')
        })
    }


    renderTabs = () => {

        return (
            <>
                <div className='row tab-header'>
                    {
                        this.tabs.map(item => (
                            <div className={`cursor-pointer col d-flex justify-content-center align-items-center ${this.state.selectedTab === item.value ? 'selected-tab-title' : ''}`}
                                onClick={() => this.changeTab(item)}>{item.title}
                                {
                                    item.value === 1 ? `${this.state.studentListLength ? `(${this.state.studentListLength})` : ''}` : ""
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    this.state.selectedTab === 1 ?
                        this.renderStandard()
                        :
                        <></>
                }

                {
                    this.state.selectedTab === 2 ?

                        this.state.payload?.revisionType === Constants.REVISION_WITH_ASSESSMENT && !this.state.isLoading ?

                            <>
                                <TestQuestionList back={this.hideQuestionList} contents={Array.isArray(this.state.contents) ? this.state.contents : []}
                                    contentsHash={this.state.selectedContentAssessment ? this.state.contentsHash : {}}
                                    questionSelection={true}
                                    questionCount={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].questionCount : (this.state.questionCount || 0)}
                                    approximateTime={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].approximateTime : (this.state.approximateTime || 0)}
                                    showTimer={this.state.payload?.showTimer}
                                    showCompetencyOnly={this.state.showCompetencyQuestionsOnly}
                                    delegate={this}
                                    isCreate={this.state.isCreate} />
                            </>

                            :
                            this.state.payload?.conceptDropownItems && this.state.payload?.conceptDropownItems.length ?
                                <div className=''>
                                    {/* <div className='mt-4 qs-font-weight'>Questions List</div> */}
                                    <div className='mt-1 apx-time-size'>
                                        <span className="question-wrapper-count-wrapper">
                                            <span>
                                                <img className='question-mark-icon' src={getImageSource(ImageConstants.QUESTION_MARK)} /> <b className="pl-1"> {this.state.questionCount || 0}</b>
                                            </span>
                                        </span>
                                        <span className="p-2 ml-3 time-count-wrapper">
                                            <span>
                                                <img className='question-mark-icon' src={getImageSource(ImageConstants.CLOCK_IMAGE)} /> <b className="pl-1">{this.state.selectedDuration?.value ? this.state.selectedDuration?.value : this.state.approximateTime || 0} </b>
                                                mins
                                            </span>
                                        </span>
                                    </div>
                                    {/* <div className='filter-title-text mt-4'>
                                    Filters
                                </div>
                                <div className='row align-items-center mt-1 skill-item-wrapper'>

                                    <div className='d-flex align-items-center '>
                                        {
                                            this.state.payload?.skillDropdownItems && this.state.payload?.skillDropdownItems?.length ?
                                                this.state.payload.skillDropdownItems.map(item => (
                                                    <div className={`ml-2 cursor-pointer skill-item ${this.state.selectedFilter.includes(item.value) ? 'selected-skill-active' : ''}`}
                                                        onClick={() => this.onClickFliter(item)}>
                                                        {item.title}
                                                    </div>
                                                ))
                                                :
                                                <></>
                                        }
                                    </div>


                                    <div className='learning-outcome-wrapper col-4 row'>
                                        {
                                            // this.user.subjectId != Constants.SCIENCE_SUBJECTID ?

                                            // <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            //     <div className="filter-input-label">
                                            //         Learning Outcome
                                            //     </div>
                                            <div className={`col ${this.user.subjectId === Constants.SCIENCE_SUBJECTID ? 'mt-3' : ''}`}>
                                                {
                                                    !this.state.reloadEloDropdown ?
                                                        <DropdownV6
                                                            key="learning"
                                                            placeholder='Select learning outcomes'
                                                            options={this.state.options && this.state.options.length ? this.state.options : []}
                                                            onSelect={(option) => this.onSelectEloFromQuestionList(option)}
                                                            value={this.state.selectedElo}
                                                            text={"title"}
                                                            multiSelect
                                                            isFilter
                                                            filterKey="skill"
                                                            filterItem={this.state.payload?.skillDropdownItems}
                                                            filterTitle="SKILL FILTERS"
                                                            isLocalSearch
                                                            selectedFilter={this.state.selectedFilter && this.state.selectedFilter.length ? this.state.selectedFilter : []}
                                                            hideSkillFilter={false}
                                                            delegate={this}
                                                        />
                                                        : ""
                                                }
                                            </div>
                                            // </div>
                                            // : ""
                                        }
                                    </div>

                                    <div className='one-question-per-elo-wrapper'>
                                        {
                                            this.state.selectOneQuestionPerELO ?
                                                <div className='d-flex align-items-center ' >
                                                    <img className="green-tick-icon-for-competency cursor-pointer" onClick={() => this.onSelectOneQuestionPerELO()} src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                                    <span className='pl-1 pt-1 cursor-pointer select-all-text' onClick={() => this.onSelectOneQuestionPerELO()}>One Question Per ELO</span>
                                                </div>
                                                :
                                                <div className='d-flex align-items-center ' onClick={() => this.onSelectOneQuestionPerELO()}>
                                                    <div className="empty-check-box cursor-pointer" onClick={() => this.onSelectOneQuestionPerELO()}></div>
                                                    <div className='ml-1 pt-1 cursor-pointer select-all-text' onClick={() => this.onSelectOneQuestionPerELO()}>One Question Per ELO</div>
                                                </div>
                                        }
                                    </div>
                                </div> */}
                                    {
                                        (this.state.payload?.revisionType != Constants.REVISION_WITH_PRACTICE || this.state.payload?.revisionType === Constants.REVISION_WITH_PRACTICE) ||
                                        (this.state.payload?.class === 'Class 10' && this.user.subjectId === Constants.SCIENCE_SUBJECTID) ?
                                            <>
                                                {/* <div className='filter-title-text mt-4'>
                                                    Filters
                                                </div> */}
                                                <div className='row'>
                                                    {
                                                        this.state.payload?.conceptDropownItems && this.state.payload?.conceptDropownItems.length ?
                                                            this.state.payload?.class === 'Class 10' && this.user.subjectId === Constants.MATHS_SUBJECTID ? <></> :
                                                                <div className="col-lg-3 col-md-6 col-sm-12 pt-2 ml-1">
                                                                    <div className="filter-input-label">
                                                                        Concept<span className='text-danger'>*</span>
                                                                    </div>
                                                                    <div className={`${this.props.isCreate && !this.state.selectedConcept ? 'error-border' : ''}
                                                                ${this.state.selectedDuration?.value ? 'disabled-concept' : ''}`}>
                                                                        {
                                                                            !this.state.reloadConceptDropdown ?
                                                                                <DropdownV4
                                                                                    key="concept-multi"
                                                                                    placeholder='Select a Concept'
                                                                                    options={this.state.payload?.conceptDropownItems}
                                                                                    onSelect={(option) => this.onMultiSelectDropdown(option, 'selectedConcept', true)}
                                                                                    text={"title"}
                                                                                    multiSelect={true}
                                                                                    value={this.state.selectedConcept}
                                                                                />
                                                                                : ""
                                                                        }
                                                                    </div>
                                                                    {this.props.isCreate && !this.state.selectedConcept ? <div className='error-text text-danger'>Please Select a concept</div> : ''}
                                                                </div>

                                                            :
                                                            <></>
                                                    }
                                                    {
                                                        this.state.availabeSets && this.state.availabeSets.length ?
                                                            this.state.payload?.class === 'Class 10' && this.user.subjectId === Constants.MATHS_SUBJECTID ? <></> :
                                                                <div className="col-lg-3 col-md-6 col-sm-12 pt-2">
                                                                    <div className="filter-input-label">
                                                                        Sets List
                                                                    </div>
                                                                    <div className={`${this.props.isCreate && !this.state.selectedSet ? 'error-border' : ''}
                                                                    ${this.state.selectedDuration?.value ? 'disabled-concept' : ''}
                                                                }`}>
                                                                        {
                                                                            !this.state.reloadSetDropdown ?
                                                                                <DropdownV4
                                                                                    key="set-multi"
                                                                                    placeholder='Select a Set'
                                                                                    options={this.state.availabeSets}
                                                                                    onSelect={(option) => this.onMultiSelectDropdown(option, 'selectedSet', false)}
                                                                                    text={"title"}
                                                                                    multiSelect={true}
                                                                                    value={this.state.selectedSet}
                                                                                />
                                                                                : ""
                                                                        }
                                                                    </div>
                                                                    {this.props.isCreate && !this.state.selectedSet ? <div className='error-text text-danger'>Please Select a Set</div> : ''}
                                                                </div>
                                                            :
                                                            <></>
                                                    }
                                                    {
                                                        this.state.payload?.class === 'Class 10' && this.user.subjectId === Constants.MATHS_SUBJECTID ? <></> :
                                                            <div className='divider-for-filter'></div>
                                                    }



                                                    {
                                                        this.state.availabeSets && this.state.availabeSets.length ?
                                                            <div className="col pt-2">
                                                                <div className="filter-input-label">
                                                                    Time/Duration <span className='text-danger'>*</span>
                                                                </div>
                                                                <div className=' d-flex align-items-center'>
                                                                    {
                                                                        this.durationList['mixed'] && this.durationList['mixed'].length && this.durationList['mixed'].map(item => (
                                                                            <div className={`duration-button ml-2 
                                                                                    ${this.state.selectedDuration?.value === item.value ? 'enable-duration' : ''}`}
                                                                                onClick={() => this.onSelectDuration('selectedDuration', item)}>{item.title}{` (${item.questionsCount} Q)`}</div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <></>
                                                    }

                                                    <div className='clear-button-wrapper' onClick={() => this.resetFilter()}>
                                                        <div className='clear-button'>Clear</div>
                                                    </div>

                                                    {/* <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                        <div className='one-question-per-elo-wrapper'>
                                                            {
                                                                this.state.selectOneQuestionPerELO ?
                                                                    <div className='d-flex align-items-center ' >
                                                                        <img className="green-tick-icon-for-competency cursor-pointer" onClick={() => this.onSelectOneQuestionPerELO(false)} src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                                                        <span className='pl-1 pt-1 cursor-pointer select-all-text' onClick={() => this.onSelectOneQuestionPerELO()}>One Question Per ELO</span>
                                                                    </div>
                                                                    :
                                                                    <div className='d-flex align-items-center ' onClick={() => this.onSelectOneQuestionPerELO(true)}>
                                                                        <div className="empty-check-box cursor-pointer" onClick={() => this.onSelectOneQuestionPerELO()}></div>
                                                                        <div className='ml-1 pt-1 cursor-pointer select-all-text' onClick={() => this.onSelectOneQuestionPerELO()}>One Question Per ELO</div>
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div> */}

                                                </div>

                                            </>
                                            :
                                            <></>

                                    }


                                    {
                                        this.state.contents.length && this.state.reloadQuestions ?
                                            <QuestionList back={this.hideQuestionList} contents={this.state.contents}
                                                contentsHash={this.state.selectedContentAssessment ? this.state.contentsHash : {}}
                                                questionSelection={this.state.questionSelection}
                                                questionCount={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].questionCount : (this.state.questionCount || 0)}
                                                approximateTime={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].approximateTime : (this.state.approximateTime || 0)}
                                                showTimer={this.state.payload?.showTimer}
                                                eloDropdownItems={this.state.payload.eloDropdownItems}
                                                skillDropdownItems={this.state.payload.skillDropdownItems}
                                                showCompetencyOnly={this.state.showCompetencyQuestionsOnly}
                                                onRefreshLOFilter={(value) => this.onRefreshLOFilter(value)}
                                                delegate={this} />
                                            :
                                            <></>
                                    }
                                </div>
                                :
                                <div className='mt-2 d-flex justify-content-center'>Please Select a Concept</div>
                        :
                        this.state.selectedTab === 2 ?
                            <div className='mt-2 d-flex justify-content-center'>No Questions Found</div>
                            :
                            <></>
                }
            </>
        )
    }

    renderAdaptiveCard(cardInfo, index) {
        return (
            <div className="homework-card-new" onDragOver={(e) => this.onDragOver(e, cardInfo)}>

                <div className={`homework-card-header py-4 px-4 ${cardInfo.colorClass} `}>
                    <div className='container-1 row'>
                        <div className='col'>
                            {cardInfo.title} |
                            {
                                cardInfo.minPercentage && cardInfo.maxPercentage ?
                                    ` ${cardInfo.minPercentage} % - ${cardInfo.maxPercentage} %` :
                                    cardInfo.minPercentage && !cardInfo.maxPercentage ?
                                        ` > ${cardInfo.minPercentage} %` :
                                        ` < ${cardInfo.maxPercentage} %`
                            }
                        </div>

                        {this.state.categories[index].selectedElo ? <div className={`mr-3 col-1`}>
                            <img className='report-icon cursor-pointer report-icon-nill-margin' src={getImageSource(ImageConstants.HAMBARGUR2)} onClick={() => this.onClickQuestionList(this.state.categories, index)} />
                        </div> : ""}
                    </div>

                </div>


                {/* <div className="mt-2 bg-white p-4">
                    <div className="criterion">
                        Learning Outcomes
                    </div>
                    <div className={`cw-card mt-2 ${this.state.selectEloMessage && !cardInfo.selectedElo?.length ? "invalid" : ""}`}>
                        {
                            !this.state.reloadDropdown ?
                                <DropdownV5
                                    disabled={this.state.eloDropdownItems.length ? false : true}
                                    key="learning"
                                    placeholder='Select learning outcomes'
                                    options={this.state.eloDropdownItems}
                                    onSelect={(option) => this.onSelectElo(option, index, cardInfo.selectedFilter)}
                                    value={cardInfo.selectedElo}
                                    text={"title"}
                                    multiSelect
                                    isFilter
                                    filterKey="skill"
                                    filterItem={this.state.skillDropdownItems}
                                    filterTitle="SKILL FILTERS"
                                    isLocalSearch
                                    selectedFilter={cardInfo.selectedFilter}
                                    skillWiseSelectedOptionsCountHash={cardInfo.skillWiseSelectedOptionsCountHash}
                                />
                                :
                                ""
                        }
                    </div>
                </div> */}

                <div className="student-list bg-white mt-2 p-4">
                    <div className="list-background p-4">
                        {
                            cardInfo.students?.length ? cardInfo.students.map((student, index) => (
                                <div className="py-2"> {
                                    this.renderStudentCard(student, cardInfo, index, this.state.isAdaptive)}
                                </div>
                            )) : <div className="text-center" style={{ 'min-width': '400px' }}>No records found </div>}
                    </div>
                </div>
            </div>
        )
    }

    renderAdaptive = () => {
        return (

            <div className="adaptive-homework row mt-5">
                {
                    this.state.categories?.length && this.state?.payload?.board && this.state?.payload?.class ? this.state.categories.map((category, index) => (
                        <div className="pr-2 col-4">
                            {this.renderAdaptiveCard(category, index)}
                        </div>
                    ))
                        : ""
                }
            </div>


        )
    }

    renderStudentGroupingByStandardHomework = () => {
        return (
            <div className='mt-3'>


                <div className='row ml-2 group-background'>


                    <div className="col-8 p-4 cursor-pointer" onClick={this.showHomeworkSelectionDropdown}>
                        {
                            this.state.selectedHomeworkBasedStudentGrouping ?
                                <div className='d-inline-block'>
                                    <img className="d-inline-block img" src={getImageSource(ImageConstants.RECT_TICK)} />
                                </div>
                                :
                                <div className='d-inline-block'>
                                    <img className="d-inline-block img" src={getImageSource(ImageConstants.RECT_BLACK1)} />
                                </div>
                        }
                        <span className='ml-3 mt-2'>Change the grouping of students below based on previous homework performance.</span>
                    </div>

                    {
                        this.state.selectedHomeworkBasedStudentGrouping ?
                            <div className='col-lg-3 col-md-6 col-sm-12 p-3 homework-input-margin-left'>
                                {!this.state.reloadDropdown ?
                                    <DropdownV4
                                        placeholder='Select Homework'
                                        options={this.state.homeworkDropdownItems}
                                        onSelect={(option) => this.getStudents(option)}
                                        text={"title"}
                                        showRadio
                                        showInfo
                                        showInfoModal={(option) => this.showHomeworkInfo(option)}
                                    // value={this.state.selectedChapter}
                                    /> : ''}

                            </div>
                            :
                            // this.state.showToaster ? <div className='custom-toaster-modal'><ToasterComponent message="Default grouping for students is restored." type="info" position="bottom-center" ></ToasterComponent></div> 
                            this.state.showToaster ? <></>
                                : ''
                    }
                </div>
            </div>
        )
    }


    showEloDetail = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideMoreInfoModal} size={'lg'}>
                <ModalBody >
                    <EloDetail back={this.hideMoreInfoModal} showHomeworkCreatedDate={true} item={this.state.selectedHomeworkMore} />
                </ModalBody>
            </Modal>
        )

    }



    render() {
        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='new-home-work-v3'>

                    <div>
                        <img alt="" className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>

                    <div className="row pt-4" >
                        {/* <div className="col screen-title">{this.props?.title || "New Classwork"}</div> */}
                        <div className="col screen-title">{this.props?.title || "New Schoolwork"}</div>
                        {/* <div className="col">
                            {this.state.payload?.concepts?.length ?
                                <button className='float-right cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.onClickCreate()}>
                                    Create Homework
                                </button>
                                :
                                <></>}
                        </div> */}
                    </div>

                    <div id='CLICKER_PRACTICE_FILTER' className='row filter-bg ml-0 mr-0' style={{
                        position: "relative",
                        paddingBottom: this.state.payload?.revisionType === Constants.ONLY_REVISION ? '4rem' : '2rem',
                        minHeight: '10rem'
                    }}>
                        <div className="col-11">
                            <Filter
                                type={this.props.type}
                                onGo={this.handleFilter}
                                delegate={this}
                                isCreate={this.state.isCreate}
                                isAdaptive={this.state.isAdaptive}
                                selectChapterMessage={this.state.selectChapterMessage}
                                selectBoardMessage={this.state.selectBoardMessage}
                                selectClassMessage={this.state.selectClassMessage}
                                selectSectionMessage={this.state.selectSectionMessage}
                                selectConceptMessage={this.state.selectConceptMessage}
                                selectDueDateMessage={this.state.selectDueDateMessage}
                                selectStreamingLogic={this.state.selectStreamingLogic}
                                selectedFilter={this.state.selectedFilter}
                                isFromDraft={this.props.isFromDraft}
                                isFinishLine={this.props.isFinishLine}
                                selectedHomework={this.props.selectedHomework}
                                isClonePractice={this.props.isClonePractice}
                            />
                            {
                                !this.state.isAdaptive ?
                                    <div className={` create-homework-absolute-for-std ${this.state.isAdaptive ? 'create-homework-absolute-adaptive' : ''} 
                                    ${this.props.moreThanOneBoard ? 'create-homework-for-more-than-one-board' : ''}`}>
                                        {this.state.payload?.concepts?.length && this.state.payload?.revisionType != Constants.REVISION_WITH_ASSESSMENT ?
                                            <div className='d-flex align-items-center flex-wrap'>
                                                <div className='d-flex flex-column'>
                                                    {/* <div className='ml-2 mr-2 homework-type-text'>Homework</div> */}
                                                    {/* <div className='d-flex mt-1 align-items-center cursor-pointer justify-content-center' onClick={() => this.changeSchoolworkType()}>
                                                        {
                                                            this.state.changeSchoolworkType ? <div className="active-check-box">
                                                                <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_TICK_ICON)} />
                                                            </div>
                                                                :

                                                                <div className="check-box"></div>
                                                        }
                                                    </div> */}
                                                </div>

                                                <div className={`float-right cursor-pointer d-flex align-items-center justify-content-center text-center create-button d-inline-block cw-btn-primary ${this.props.moreThanOneBoard ? 'create-button-for-more-than-one-board' : ''}`}
                                                    onClick={() => this.onClickCreate()}
                                                    style={{ marginTop: this.state.payload?.revisionType === Constants.ONLY_REVISION ? '2.5rem' : '1.5rem' }}>
                                                    Create
                                                </div>
                                            </div>
                                            :
                                            this.state.payload?.chapter?.length && this.state.payload?.revisionType === Constants.REVISION_WITH_ASSESSMENT ?
                                                <div className='d-flex align-items-center flex-wrap'>
                                                    <div className='d-flex flex-column'>
                                                        {/* <div className='ml-2 mr-2 homework-type-text'>Homework</div> */}
                                                        {/* <div className='d-flex mt-1 align-items-center cursor-pointer justify-content-center' onClick={() => this.changeSchoolworkType()}>
                                                        {
                                                            this.state.changeSchoolworkType ? <div className="active-check-box">
                                                                <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_TICK_ICON)} />
                                                            </div>
                                                                :

                                                                <div className="check-box"></div>
                                                        }
                                                    </div> */}
                                                    </div>

                                                    <div className={`float-right cursor-pointer d-flex align-items-center justify-content-center text-center create-button d-inline-block cw-btn-primary ${this.props.moreThanOneBoard ? 'create-button-for-more-than-one-board' : ''}`} onClick={() => this.onClickCreateDiganosticAssessment()}>
                                                        Create
                                                    </div>
                                                </div>
                                                :
                                                <></>}
                                    </div>
                                    :
                                    <div className={`create-homework-absolute ${this.state.isAdaptive ? 'create-homework-absolute-adaptive' : ''} 
                                    ${this.props.moreThanOneBoard ? 'create-homework-absolute-adaptive-for-more-than-one-board' : ''}`}>
                                        {this.state.payload?.concepts?.length ?
                                            <div className='d-flex align-items-center'>
                                                {/* <div className='d-flex flex-column'>
                                                    
                                                    <div className='d-flex mt-1 align-items-center cursor-pointer justify-content-center' onClick={() => this.changeSchoolworkType()}>
                                                        {
                                                            this.state.changeSchoolworkType ? <div className="active-check-box">
                                                                <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_TICK_ICON)} />
                                                            </div>
                                                                :

                                                                <div className="check-box"></div>
                                                        }
                                                    </div>
                                                </div> */}

                                                <div className={`float-right cursor-pointer d-flex align-items-center justify-content-center text-center create-button-for-adaptive d-inline-block cw-btn-primary ${this.props.moreThanOneBoard ? 'create-button-for-adaptive-for-more-than-one-board' : ''}`} onClick={() => this.onClickCreate()}>
                                                    Create
                                                </div>
                                            </div>
                                            :
                                            <></>}
                                    </div>
                            }
                        </div>

                        <div className="col-1 info-position">
                            <div className="text-center">
                                <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.INFO1)} onClick={this.onClickInfo} />
                            </div>
                        </div>
                    </div>

                    {!this.state.isAdaptive ?
                        this.state.payload?.chapter?.length ?
                            <div key={"1-row"} className=" qs-margin-top p-2">
                                <span className="table-row-1 p-2 ml-3">
                                    <img className='question-mark-icon' src={getImageSource(ImageConstants.WHITE_QUESTION_MARK)} />
                                    <span>
                                        <span className='question-number-text'>Number of Questions</span> <b className="pl-2"> {this.state.questionCount || 0}</b></span>
                                </span>
                                <span className="table-row-1  p-2 ml-5">
                                    <img className='question-mark-icon' src={getImageSource(ImageConstants.WHITE_TIMER_ICON)} />
                                    <span><span className='question-number-text'>Approximate Time</span> <b className="pl-2">
                                        {this.state.selectedDuration?.value ? this.state.selectedDuration?.value : this.state.approximateTime || 0} </b>mins</span>
                                </span>
                                {/* <span className='' align='right'>
                                    <span className="qs-image-float">
                                        <img className='report-icon-new cursor-pointer' src={getImageSource(ImageConstants.HANBARGUR_NEW)} onClick={() => this.onClickQuestionList()} />
                                    </span>
                                </span> */}
                            </div>
                            : <div className=" p-2 qs-margin-top"><div colSpan="5" align='center'><span>Please select a Concept</span></div></div>
                        : ''}
                    {
                        this.state.isAdaptive && this.state.homeworkDropdownItems.length > 0 ? this.renderStudentGroupingByStandardHomework() : ''
                    }

                    <div className="mt-3">
                        {this.state.isAdaptive ? this.renderAdaptive() : this.renderTabs()}
                    </div>
                    {
                        this.state.showInfoModal ? this.showConceptDetail() : ""
                    }
                    {
                        this.state.showQuestionList ? this.showQuestionList() : ""
                    }
                    {
                        this.state.showMoreInfo ? this.showEloDetail() : ""
                    }
                    {
                        this.state.showStudentToaster ? <div className='custom-toaster-modal'><ToasterComponent message="Students are now grouped as per their last homework performance." type="info" position="bottom-center" ></ToasterComponent></div> : ''

                    }
                    {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
                </div>
            </>);
    }
}

export default NewHomeWork;